import clsx from 'clsx'
import { IQRCodeProps, IThemedColor, ColorType, CustomCSSProperties } from './types'
import styles from './styles.module.scss'
import QRCodeComponent from 'react-qr-code'

function isThemedColor(color: ColorType): color is IThemedColor {
  return typeof color === 'object' && 'light' in color && 'dark' in color
}

const QRCode = ({
  size = 256,
  value,
  bgColor = 'transparent',
  fgColor,
  level = 'L',
}: IQRCodeProps) => {
  const isFgColorThemed = fgColor && isThemedColor(fgColor)
  const isBgColorThemed = isThemedColor(bgColor)
  const style: CustomCSSProperties = {
    ...(isFgColorThemed && { '--qrcode-fg-color-light': fgColor?.light }),
    ...(isFgColorThemed && { '--qrcode-fg-color-dark': fgColor?.dark }),
    ...(isBgColorThemed && { '--qrcode-bg-color-light': bgColor?.light }),
    ...(isBgColorThemed && { '--qrcode-bg-color-dark': bgColor?.dark }),
  }
  return (
    <div
      className={clsx(styles.QRCode, styles[size], {
        [styles.noFG]: fgColor === undefined,
        [styles.themedFG]: isFgColorThemed,
        [styles.themedBG]: isBgColorThemed,
      })}
      style={style}
    >
      <QRCodeComponent
        bgColor={typeof bgColor === 'string' ? bgColor : undefined}
        fgColor={typeof fgColor === 'string' ? fgColor : undefined}
        size={size}
        value={value}
        viewBox={`0 0 ${size} ${size}`}
        level={level}
      />
    </div>
  )
}

export default QRCode
